<!-- 市场动态 -->
<script>
import * as echarts from "echarts";
import {
    getVarietyMajorCategories,
    getVarietyNameByPid,
    getSingleVarietiesCountry
} from "../api/agri";
export default {
    name: "dynamic",
    data() {
        return {
            loading: true,
            chart: null,
            selectMainClass: "",
            selectMainClassType: "",
            mainClass: [],
            selectSubClass: "",
            subClass: [],
            selectCycle: "近一年",
            cycle: ["近7日", "近一月", "近半年", "近一年"],
            chartData: {
                data: [],
                price: [],
                x: [],
                y: []
            }
        };
    },
    mounted() {
        this.setup();
    },
    computed: {
        // 最高价格
        highPrice() {
            if (this.chartData.price[1] !== undefined) {
                return this.chartData.price[1].middlePrice;
            }
            return "--";
        },
        // 最高价格出现的市场
        highPriceName() {
            if (this.chartData.price[1] !== undefined) {
                return this.chartData.price[1].marketName;
            }
            return "--";
        },
        // 最高价格出现的日期
        highPriceDate() {
            if (this.chartData.price[1] !== undefined) {
                return this.chartData.price[1].reportTime;
            }
            return "--";
        },
        // 最低价格
        lowPrice() {
            if (this.chartData.price[0] !== undefined) {
                return this.chartData.price[0].middlePrice;
            }
            return "--";
        },
        // 最低价格出现的市场
        lowPriceName() {
            if (this.chartData.price[0] !== undefined) {
                return this.chartData.price[0].marketName;
            }
            return "--";
        },
        // 最低价格出现的日期
        lowPriceDate() {
            if (this.chartData.price[0] !== undefined) {
                return this.chartData.price[0].reportTime;
            }
            return "--";
        }
    },
    methods: {
        // 初始化
        async setup () {
            // 缓存中是否有大类数据
            // 有从缓存中拿；没有在请求数据
            const mainClass = localStorage.getItem("dynamic-main-class");
            if (mainClass === null) {
                await this.getMainClass();
            } else {
                // 所有大类
                this.mainClass = JSON.parse(mainClass);
                // 选中的大类名称
                const selectMainClass = localStorage.getItem("dynamic-select-main-class-name");
                if (selectMainClass === null && this.mainClass.length !== 0) {
                    this.selectMainClass = this.mainClass[0].name;
                } else {
                    this.selectMainClass = selectMainClass;
                }
                // 选中的大类类型
                const selectMainClassType = localStorage.getItem("dynamic-select-main-class-type");
                if (selectMainClassType === null && this.mainClass.length !== 0) {
                    this.selectMainClassType = this.mainClass[0].type;
                } else {
                    this.selectMainClassType = selectMainClassType;
                }
            }
            // 缓存中是否有小类数据
            // 有从缓存中拿；没有在请求数据
            const subClass = localStorage.getItem("dynamic-sub-class");
            if (subClass === null) {
                await this.getSubClass(this.selectMainClassType);
            } else {
                this.subClass = JSON.parse(subClass);
                // 选中的小类名称
                const selectSubClass = localStorage.getItem("dynamic-select-sub-class-name");
                if (selectSubClass === null && this.subClass.length !== 0) {
                    this.selectSubClass = this.subClass[0].name;
                } else {
                    this.selectSubClass = selectSubClass;
                }
            }
            // 缓存中是否有周期数据
            // 有从缓存中拿
            const cycle = localStorage.getItem("dynamic-cycle-name");
            if (cycle !== null) {
                this.selectCycle = cycle;
            }
            // 请求图表数据
            if (this.selectMainClass !== "" && this.selectSubClass !== "" && this.selectCycle !== "") {
                await this.getChartData();
            }
            // 绑定图表调整尺寸监听函数
            window.addEventListener("resize", this.resizeChart);
            // 取消加载状态
            this.loading = false;
            // 刷新图表
            this.$nextTick(() => {
                this.chart = echarts.init(document.getElementById("dynamic-chart"));
                this.refreshChart();
            });
        },
        // 获取大类数据
        async getMainClass() {
            try {
                const res = await getVarietyMajorCategories();
                console.log(res);
                if (res && res.data && res.data.data.code === 200 && res.data.data.message === "请求处理成功" && res.data.data.content instanceof Array) {
                    const list = res.data.data.content.map(item => ({
                        id: item.id,
                        name: item.varietyTypeName,
                        type: item.varietyTypeCode
                    }));
                    if (list.length !== 0) {
                        this.selectMainClass = list[0].name;
                        this.selectMainClassType = list[0].type;
                        this.cacheSelectMainClass();
                    }
                    this.mainClass = list;
                    this.cacheMainClass();
                }
            } catch(e) {
                console.log(e);
            }
        },
        // 选择大类
        async handleSelectMainClass(name) {
            this.selectMainClass = name;
            const index = this.mainClass.findIndex(item => item.name === name);
            this.selectMainClassType = this.mainClass[index].type;
            this.cacheSelectMainClass();
            await this.getSubClass(this.selectMainClassType);
            // 获取对应图表数据
            await this.getChartData();
            // 刷新数据
            this.refreshChart();
        },
        // 缓存选中大类信息
        cacheSelectMainClass() {
            localStorage.setItem("dynamic-select-main-class-name", this.selectMainClass);
            localStorage.setItem("dynamic-select-main-class-type", this.selectMainClassType);
        },
        // 缓存大类信息
        cacheMainClass() {
            localStorage.setItem("dynamic-main-class", JSON.stringify(this.mainClass));
        },
        // 获取小类数据
        async getSubClass(type) {
            try {
                const res = await getVarietyNameByPid(type);
                console.log(res);
                if (res && res.data && res.data.data && res.data.data.code === 200 && res.data.data.message === "请求处理成功" && res.data.data.content instanceof Array) {
                    let list = [];
                    for (let i = 0; i < res.data.data.content.length; i++) {
                        list = list.concat(res.data.data.content[i]);
                    }
                    list = list.map(item => ({
                        id: item.id,
                        name: item.varietyName
                    }));
                    if (list.length !== 0) {
                        this.selectSubClass = list[0].name;
                        this.cacheSelectSubClass();
                    }
                    this.subClass = list;
                    this.cacheSubClass();
                }
            } catch(e) {
                console.log(e);
            }
        },
        // 选择小类
        async handleSelectSubClass(name) {
            this.selectSubClass = name;
            this.cacheSelectSubClass();
            // 获取对应图表数据
            await this.getChartData();
            // 刷新数据
            this.refreshChart();
        },
        // 缓存选中小类信息
        cacheSelectSubClass() {
            localStorage.setItem("dynamic-select-sub-class-name", this.selectSubClass);
        },
        // 缓存小类信息
        cacheSubClass() {
            localStorage.setItem("dynamic-sub-class", JSON.stringify(this.subClass));
        },
        // 选择周期
        async handleSelectCycle(name) {
            this.selectCycle = name;
            this.cacheSelectCycle();
            // 获取对应图表数据
            await this.getChartData();
            // 刷新数据
            this.refreshChart();
        },
        // 缓存选中周期信息
        cacheSelectCycle() {
            localStorage.setItem("dynamic-cycle-name", this.selectCycle);
        },
        // 获取图表数据
        async getChartData() {
            try {
                const res = await getSingleVarietiesCountry({
                    order: "ASC",
                    name: this.selectSubClass,
                    cycle: this.selectCycle
                });
                if (res && res.data && res.data.data && res.data.data.code === 200 && res.data.data.message === "请求处理成功" && res.data.data.content !== null) {
                    this.chartData = res.data.data.content;
                }
            } catch(e) {
                console.log(e);
            }
        },
        // 缩放图表
        resizeChart() {
            if (this.chart !== null) {
                this.chart.resize();
            }
        },
        // 刷新图表
        refreshChart() {
            this.chart.clear();
            if (this.chartData.x.length === 0 && this.chartData.y.length === 0) {
                // 无数据的配置信息
                let options = {
                    title: {
                        text: "当前大类/小类/周期下无数据",
                        left: "center",
                        top: "center",
                        textStyle: {
                            fontSize: 14,
                            color: "#808695"
                        }
                    },
                };
                this.chart.setOption(options);
                return;
            }
            // 有数据的配置信息
            let options = {
                grid: {
                    top: "14%",
                    bottom: "12%",
                    left: "6%",
                    right: "2%"
                },
                tooltip: {
                    show: true,
                    formatter: `{b0}<br />${this.selectSubClass}：{c0}元`,
                    trigger: "axis",
                    axisPointer: {
                        lineStyle: {
                            color: "#23fffc"
                        }
                    }
                },
                xAxis: {
                    type: "category",
                    data: this.chartData.x,
                    axisLabel: {
                        textStyle: {
                            color: "#a7a7a7"
                        },
                        padding: 1
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#435d73"
                        },
                    },
                    axisTick: {
                        show: false
                    }
                },
                yAxis: {
                    type: "value",
                    data: this.chartData.y,
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#a7a7a7"
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#435d73"
                        }
                    }
                },
                series: [
                    {
                        data: this.chartData.y,
                        type: "line",
                        smooth: true,
                        symbol: "circle",
                        symbolSize: 5,
                        lineStyle: {
                            color: "#00aee2",
                            width: 2
                        },
                        itemStyle: {
                                color: "#0ab7ed"
                        },
                        emphasis: {
                            scale: 1.2,
                            itemStyle: {
                                color: "#0ab7ed"
                            }
                        },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                {
                                    offset: 0,
                                    color: "rgba(0, 173, 223, 0)"
                                },
                                {
                                    offset: 1,
                                    color: "rgb(0, 174, 226, 1)"
                                }
                            ])
                        }
                    }
                ]
            };
            this.chart.setOption(options);
        },
        handleFlag(){
            this.$emit('handleChange')
        }
    },
    destroyed() {
        window.removeEventListener("resize", this.resizeChart);
    }
};
</script>

<template>
    <div class="dynamic">
        <header>
            <div class="header-left">市场动态 <img @click="handleFlag" class="header-left-img" src="../assets/change-icon.png.png"></div>
            <div class="header-right">
                <!-- 选择大类 -->
                <div class="select-box select-label-interval">
                    <div class="select-label">品类</div>
                    <Dropdown
                        class="dropdown"
                        @on-click="handleSelectMainClass">
                        <div class="dropdown-label">
                            <span class="dropdown-label-name">
                                {{ selectMainClass }}
                            </span>
                            <Icon
                                class="dropdown-label-icon"
                                type="md-arrow-dropdown" />
                        </div>
                        <DropdownMenu
                            class="dropdown-list"
                            slot="list">
                            <DropdownItem
                                v-for="item in mainClass"
                                :key="item.id"
                                :name="item.name">
                                {{ item.name }}
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
                <!-- 选择小类 -->
                <div class="select-box select-label-interval">
                    <div class="select-label">小类</div>
                    <Dropdown
                        class="dropdown"
                        @on-click="handleSelectSubClass">
                        <div class="dropdown-label">
                            <span class="dropdown-label-name">
                                {{ selectSubClass }}
                            </span>
                            <Icon
                                class="dropdown-label-icon"
                                type="md-arrow-dropdown" />
                        </div>
                        <DropdownMenu
                            class="dropdown-list"
                            slot="list">
                            <DropdownItem
                                v-for="item in subClass"
                                :key="item.id"
                                :name="item.name">
                                {{ item.name }}
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
                <!-- 选择周期 -->
                <div class="select-box">
                    <div class="select-label">周期</div>
                    <Dropdown
                        class="dropdown"
                        @on-click="handleSelectCycle">
                        <div class="dropdown-label">
                            <span class="dropdown-label-name">
                                {{ selectCycle }}
                            </span>
                            <Icon
                                class="dropdown-label-icon"
                                type="md-arrow-dropdown" />
                        </div>
                        <DropdownMenu
                            class="dropdown-list"
                            slot="list">
                            <DropdownItem
                                v-for="item in cycle"
                                :key="item"
                                :name="item">
                                {{ item }}
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </div>
        </header>
        <!-- 加载样式 -->
        <Spin class="loading" v-if="loading">
            <div class="loading-container">
                <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">加载中</div>
            </div>
        </Spin>
        <!-- 图表 -->
        <div class="content" v-else>
            <div class="prices">
                <div class="prices-item prices-high">
                    <div class="prices-item-price">
                        最高价格
                        <span class="price high-price">{{ highPrice }}</span>
                        元
                    </div>
                    <div class="prices-item-market">{{ highPriceName }}</div>
                    <div class="prices-item-date">{{ highPriceDate }}</div>
                </div>
                <div class="prices-item prices-low">
                    <div class="prices-item-price">
                        最低价格
                        <span class="price low-price">{{ lowPrice }}</span>
                        元
                    </div>
                    <div class="prices-item-market">{{ lowPriceName }}</div>
                    <div class="prices-item-date">{{ lowPriceDate }}</div>
                </div>
            </div>
            <div id="dynamic-chart" class="chart-box"></div>
        </div>
    </div>
</template>

<style scoped>
.dynamic {
    position: absolute;
    top: calc((100% - 80px) / 3 + 40px);
    right: 20px;
    width: 26.615vw;
    height: calc((100% - 80px) / 3);
    background-color: rgba(0, 40, 69, 0.8);
    border-radius: 0.5vw;
}

header {
    position: relative;
    width: 100%;
    height: 20%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header-left {
    font-size: 1.172vw;
    color: #ffffff;
    padding-left: 1vw;
}
.header-left-img{
    height:1.5vh;
    cursor: pointer;
}
.header-right {
    padding-right: 1vw;
    display: flex;
    align-items: center;
}

.select-box {
    display: flex;
    align-items: center;
}

.select-label {
    font-size: 0.5vw;
}

.select-label-interval {
    margin-right: 0.5vw;
}

.dropdown {
    margin-left: 0.5vw;
    width: 4.2vw;
    background-color: #000c15;
    padding: 0.1vw 0.3vw;
}

.dropdown-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.dropdown-label-name {
    max-width: 6vw;
    font-size: 0.6vw;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding-left: 0.2vw;
}

.dropdown-label-icon {
    font-size: 1vw;
    color: #00cdff;
}

.dropdown >>> .ivu-select-dropdown {
    background-color: #000c15;
    margin: 8px 0px;
    padding: 0px;
}

.ivu-dropdown-item {
    color: #ffffff;
    padding: 0.1vw 0.3vw;
    width: 4.2vw;
    font-size: 0.6vw !important;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.ivu-dropdown-item:hover {
    background-color: rgba(255, 255, 255, 0.2);
}

.dropdown-list {
    min-width: 4.2vw;
    max-height: 8vw;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #000c15;
}

.dropdown-list::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}

.dropdown-list::-webkit-scrollbar-thumb {
    background-color: #dcdee2;
    border-radius: 2px;
}

.content {
    position: relative;
    width: 100%;
    height: 80%;
    padding-left: 1vw;
    padding-right: 1vw;
    padding-bottom: 1vw;
}

.chart-box {
    width: 100%;
    height: calc(100% - 4.05vw);
}

.loading {
    position: relative;
    width: 100%;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.loading-container {
    display: flex;
    align-items: center;
}

.loading-text {
    font-size: 0.6vw;
    padding-left: 0.2vw;
}

.prices {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 4.05vw;
}

.prices-item {
	width: 9.8vw;
	height: 4.05vw;
    background-repeat: no-repeat;
    background-size: cover;
    padding-left: 1.25vw;
    padding-right: 0.4vw;
}

.prices-high {
    background-image: url("../assets/high-price-bg.png");
}

.prices-low {
    background-image: url("../assets/low-price-bg.png");
}

.prices-item-price {
    font-size: 0.667vw;
    color: #ffffff;
    padding-top: 0.3vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.price {
    font-size: 0.934vw;
    padding: 0px 4px;
}

.high-price {
    color: #23fffc;
}

.low-price {
    color: #00aee2;
}

.prices-item-market {
    font-size: 0.667vw;
    color: #a7a7a7;
    padding-top: 0.05vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.prices-item-date {
    font-size: 0.534vw;
    color: #a7a7a7;
    padding-top: 0.05vw;
}
</style>
